import { z } from 'zod';
import { Pegasus } from '../../schema/pegasus.js';
import { variant } from '../../schema/storeProduct.js';
const option = z.object({ name: z.string(), position: z.number() });
export const productOptions = z.array(option);
const product = z.object({
    idFromPlatform: z.string(),
    name: z.string(),
    imageUrl: z.string().nullable(),
    hasOnlyDefaultVariant: z.boolean(),
    createdOn: z.string().optional(),
    productType: z.string().optional(),
});
export const productWithOptions = product.extend({
    options: z.array(option.merge(z.object({ values: z.array(z.string()) }))),
    variants: z.array(variant),
});
const productFilter = z.object({
    name: z.string(),
    values: z.array(z.string()),
    type: z.literal('option'),
});
export const exchangeRecommendation = z.object({
    customerRecommendationMessage: z.string().optional(),
    method: z.enum([
        'sameVariant',
        'historicalExchange',
        'aiVariantSwap',
        'aiPopular',
        'aiProductType',
    ]),
    product,
    variant,
});
export const exchangeRecommendationQuery = z.object({
    variantIdFromPlatform: z.string().optional(),
    reasonId: z.coerce.number().optional(),
    comment: z.string().optional(),
    reasonDetailId: z.coerce.number().optional(),
    countryCode: z.string().optional(),
    isExchangeOfExchange: z
        .union([z.literal('true'), z.literal('false')])
        .transform((val) => val === 'true')
        .optional(),
});
// * variant exchange
export const productVariantExchangeResponse = z.object({
    exchangeRecommendation: exchangeRecommendation.optional(),
    advancedExchangeMethod: Pegasus.advancedExchangeMethodUnion,
    isFilterAndSearchEnabled: z.boolean(),
    isNoAdjustmentVariantExchangeEnabled: z.boolean(),
    filters: z.array(productFilter).optional(),
    products: z.array(productWithOptions),
});
export const collection = z.object({
    id: z.number(),
    title: z.string(),
    description: z.string().optional(),
});
//# sourceMappingURL=variantExchange.js.map